import type { DisciplineActivationPayload } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineActivationUpdateApiOptions {
  disciplineId: string | number
  payload: DisciplineActivationPayload
  onStart?: () => void
  onFinish?: () => void
}

/** `PATCH /admin-api/disciplines/{discipline}/activation` — answers `[]`; the caller rereads the details, since a
 *  stage change runs kanban automations that can override what was sent. */
export const useDisciplineActivationUpdateApi = async (options: DisciplineActivationUpdateApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const url = useAdminRoutes('admin.disciplines.api.activation', { discipline_id: options.disciplineId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.patch<ApiResponse>(url, options.payload)

    toast.success('Activation info was changed successfully.')

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
